'use strict';

import FormController from 'app/controllers/form';
import AssignationsService from 'services/assignations.service';
import * as moment from 'moment';

// eslint-disable no-unused-vars
import WorkersService from 'services/workers.service';
import RegistriesService from 'services/registries.service';
//

export default class AssignationController extends FormController {
  AssignationsService: AssignationsService;
  WorkersService: WorkersService;
  RegistriesService: RegistriesService;
  $scope: any;
  $state: any;
  $mdToast: any;
  $mdDialog: any;
  $location: any;

  model: any;
  form: any;
  showSpin: boolean;
  editable: boolean;
  editing: boolean;

  operation: any;
  worker: any;
  registry: any;
  searchWorkerText: string;

  static $inject = [
    'AssignationsService',
    'WorkersService',
    'RegistriesService',
    '$scope',
    '$state',
    '$mdToast',
    '$mdDialog',
    '$location',
    '$stateParams'
  ];
  constructor(
    AssignationsService,
    WorkersService,
    RegistriesService,
    $scope,
    $state,
    $mdToast,
    $mdDialog,
    $location,
    $stateParams
  ) {
    const { operationProcedureId } = $stateParams;
    const assignation = $scope.$parent.$resolve.assignation;
    const operation = $scope.$parent.$resolve.operation;
    super(assignation, 'Asignacion', AssignationsService, null, 'assignations');

    Object.assign(this, {
      AssignationsService,
      WorkersService,
      RegistriesService,
      operation,
      $scope,
      $state,
      $mdToast,
      $mdDialog,
      $location
    });

    if (this.model.id) {
      Object.assign(this, {
        worker: this.model.worker,
        operation: this.model.operation,
        registry: this.model.registry
      });
    } else {
      const operationProcedure = operationProcedureId
        ? {
            operationProcedure: operation.operationProcedures.find(
              op => op.id == operationProcedureId
            )
          }
        : {};
      // Default values
      Object.assign(this.model, {
        date: moment()
          .add(1, 'days')
          .toDate(),
        operation,
        amount: 0,
        ...operationProcedure
      });
    }
  }

  $onInit() {
    super.$onInit();
  }

  queryWorkerSearch() {
    return this.WorkersService.getModels({
      where: {
        name: {
          ilike: `%${this.searchWorkerText}%`
        }
      },
      order: 'name ASC'
    });
  }

  queryRegistrySearch(text) {
    return this.RegistriesService.getModels({
      where: {
        name: {
          ilike: `%${text}%`
        }
      },
      order: 'name ASC'
    });
  }

  setWorker(worker) {
    this.worker = worker;
    this.model.worker = worker;
    this.model.workerId = worker.id;
  }

  setRegistry(registry) {
    this.registry = registry;
    this.model.registry = registry;
    this.model.registryId = registry.id;
  }
}
